<template>
    <div class="page" v-if="show">
        <div class="comment">
            <div class="title">
                <span>写评论</span>
                <div class="btn" @click="cancel">取消</div>
            </div>
            <div class="comment-input td-fsc">
                <div class="textarea td-f1">
                    <textarea name="" rows="4" v-model="form.content" placeholder="请输入"></textarea>
                </div>
                <van-uploader class="van-uploader" v-if="image" :max-size="uploaderMaxSize.imageMaxSize * 1024" @oversize="_onOversize" :max-count="1" v-model="uploader" :after-read="afterRead" />
            </div>
            <div class="comment-btn td-fbc">
                <div></div>
                <div class="btn td-fcc" @click="submit">提交</div>
            </div>
        </div>
        <div class="mask"></div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { QiniuUpload } from "../utils/qiniuUpload";
export default {
    name: "comment-input",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        image: {
            type: [Boolean, String],
            default: false,
        },
    },
    computed: {
        ...mapGetters(["userInfo"]),
    },
    data() {
        return {
            qiniuInfo: {},
            uploaderMaxSize: {},
            form: {
                content: "",
                img_src: '', // "https://qiniu.ys141319.com/202105/FiS3Ii1KXHiQyYIN_0QwTTGmhNmi.jpg",
            },
            file: null,
            uploader: [],
        };
    },
    created() {
        this.getQiniuData();
    },
    methods: {
        
        _onOversize(file) {
            console.log('file---->', file);
            this.ToastManager('图片大小不能超过：' + (this.uploaderMaxSize.imageMaxSize / 1024) + 'M');
        },

        async getQiniuData() {
            let url = this.API.qiniuToken;
            let params = {};
            let result = await this.$post(url, params);
            this.qiniuInfo = result;
            this.uploaderMaxSize = result.uploaderMaxSize;
            console.log();
        },
        afterRead(file) {
            // 此时可以自行将文件上传至服务器
            this.file = file;
        },
        // 取消
        cancel() {
            this.$emit("callback", {
                type: "cancel",
            });
        },
        // 提交
        submit() {
            let { form } = this;
            if (!form.content) {
                return this.Message({
                    title: "请输入内容",
                });
            }
            if (this.uploader.length) {
                if (this.IMAGES_DRIVER == this.Constants.DRIVER_QINIUKODO) {
                    const toast = this.$toast.loading({
                        duration: 0,
                        message: "上传中...",
                        forbidClick: true,
                    });
                    QiniuUpload(this.qiniuInfo, this.file).then((res) => {
                        toast.clear()
                        this.form.img_src = this.qiniuInfo.domain + res.key;
                        this.$emit("callback", {
                            type: "success",
                            data: this.form,
                        });
                    });
                }
                if (this.IMAGES_DRIVER == this.Constants.DRIVER_ALIOSS) {
                    this._onUploadImageToAliOss(this.file);
                }
                if (this.IMAGES_DRIVER == this.Constants.DRIVER_TENCENTCOS) {

                }
            } else {
                this.$emit("callback", {
                    type: "success",
                    data: this.form,
                });
            }
        },

        // 上传阿里云
        async _onUploadImageToAliOss(file) {
            let url = this.API.uploadToAliOss;
            let params = {
                file: file.file,
                uid: this.userInfo.id,
            };
            const toast = this.$toast.loading({
                duration: 0,
                message: "上传中...",
                forbidClick: true,
            });
            let result = await this.$uploadFormData(url, params);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                toast.clear()
                this.form.img_src = result.url;
                this.$emit("callback", {
                    type: "success",
                    data: this.form,
                });
            }
        },
    },
};
</script>
<style lang="less" scoped>
.page {
    .mask {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.4);
    }

    .comment {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1000;
        background-color: #fff;
        border-radius: 10px 10px 0 0;
        overflow: hidden;

        .title {
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            border-bottom: solid #eee 1px;

            span {
                font-size: 15px;
                color: #333;
            }

            .btn {
                height: 40px;
                padding: 0 20px;
                position: absolute;
                top: 0;
                right: 0;
                font-size: 14px;
                color: #6472e8;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .comment-input {
            background-color: #f8f8f8;
            margin: 15px;
            border-radius: 6px;

            textarea {
                width: 100%;
                box-sizing: border-box;
                padding: 10px;
                font-size: 14px;
                line-height: 20px;
                border: none;
                background-color: transparent;
                word-break: break-all;
                text-align: justify;
            }

            .img-box {
                position: relative;
                margin: 20px;

                .img {
                    width: 80px;
                    height: 80px;
                    object-fit: contain;
                }

                .del {
                    width: 25px;
                    height: 25px;
                    position: absolute;
                    top: -10px;
                    right: -10px;
                    z-index: 1;
                }
            }
        }

        .comment-btn {
            margin: 10px 15px;

            .upload-img {
                width: 40px;
                height: 40px;
                display: block;
            }

            .btn {
                height: 28px;
                width: 72px;
                font-size: 14px;
                letter-spacing: 2px;
                color: #fff;
                font-weight: 500;
                border-radius: 20px;
                background: linear-gradient(225deg, #9cb2f4, #6472e8);
            }
        }
    }
}

.van-uploader {
    /deep/ .van-uploader__upload {
        border: solid #dbdbdb 1px;
    }
}
</style>